import React, { PureComponent } from 'react';
import { Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useBasicAuth } from '../../shared/components/auth/withBasicAuth';
import { util } from "../../shared/util";

// const hist = createBrowserHistory()

class Home extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
    };
    useBasicAuth.checkToken();
  }

  render() {
    return (
      <Container className="dashboard">
        <Row>
        </Row>
      </Container>
    );
  }
}

export default withTranslation('common')(Home);
